
    <div class="preloader" *ngIf="baThemeSpinner.isShown()">
      <div></div>
    </div>
  